/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, FileData, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../request'

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig
}

const mockUrl_0_0_0_45 = 'http://127.0.0.1:50505/mock/0' as any
const devUrl_0_0_0_45 = '' as any
const prodUrl_0_0_0_45 = '' as any
const dataKey_0_0_0_45 = 'data' as any

/**
 * 接口 添加新品草稿 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/addDraftNewProduct`
 */
export interface AddDraftNewProductRequest {
  /**
   * 旺旺号
   */
  ali_wangwang?: string
  /**
   * 到货/生产天数
   */
  arrival_days?: number
  /**
   * 新品产品描述
   */
  base_description?: string
  /**
   * 是否能提供整箱配送 0:否 1:能
   */
  box_able?: number
  /**
   * 整箱尺寸高（最短边）
   */
  box_high?: number
  /**
   * 整箱尺寸长(最长边)
   */
  box_length?: number
  /**
   * 整箱个数
   */
  box_num?: number
  /**
   * 整箱重量
   */
  box_weight?: number
  /**
   * 整箱尺寸宽（次长边）
   */
  box_width?: number
  /**
   * 品牌名
   */
  brands_name?: string
  /**
   * 删除的证书id
   */
  certification_ids?: number[]
  /**
   * 产品资料及认证证书
   */
  certification_link?: {
    /**
     * 文件名
     */
    file_name?: string
    /**
     * 文件路径
     */
    file_path?: string
  }[]
  /**
   * 中文名
   */
  chinese_name?: string
  /**
   * 服装面料成分
   */
  clothing_composition_name?: string
  /**
   * 默认图片
   */
  default_img_link?: string
  /**
   * 删除属性ID集合
   */
  del_poa?: number[]
  /**
   * 英文名
   */
  english_name?: string
  /**
   * 其他类属性描述集合
   */
  etc_property_descriptions?: {
    key?: string
    value?: string
  }[]
  /**
   * 推荐类型: 0-普通推新;1-自主上架
   */
  ewd_recommend_type?: number
  /**
   * 预测体积高
   */
  forecast_height?: number
  /**
   * 预测体积长
   */
  forecast_length?: number
  /**
   * 预测体积宽
   */
  forecast_width?: number
  /**
   * 新品ID
   */
  id?: number
  /**
   * 删除的图片id
   */
  img_ids?: number[]
  /**
   * 图片
   */
  img_link?: string[]
  /**
   * 是否转接头
   */
  is_adapter?: boolean
  /**
   * 是否无条件包邮
   */
  is_exemptpostage?: number
  /**
   * 是否显示四季标签，服装特性，适用年龄
   */
  is_show?: boolean
  /**
   * 最小订货量
   */
  min_num?: number
  /**
   * 新品类型(0:电子 1:服装)
   */
  new_product_type?: number
  /**
   * 包装清单描述
   */
  package_description?: string
  /**
   * POA颜色
   */
  poa_color?: string
  /**
   * 属性信息
   */
  poa_infos?: {
    /**
     * 到货/生产天数
     */
    arrival_days?: number
    /**
     * 最短边
     */
    box_high?: number
    /**
     * 最长边
     */
    box_length?: number
    /**
     * 次长边
     */
    box_width?: number
    /**
     * ID
     */
    id?: number
    /**
     * 最小订货量
     */
    min_num?: number
    /**
     * POA颜色
     */
    poa_color?: string
    /**
     * POA尺码/其他
     */
    poa_size?: string
    /**
     * POA尺码类型
     */
    poa_size_type?: number
    /**
     * 价格（元）
     */
    price?: number
    /**
     * 属性图片信息
     */
    property_images?: {
      /**
       * 图片Id
       */
      id?: number
      /**
       * 是否默认
       */
      is_default?: boolean
      /**
       * 是否删除
       */
      is_deleted?: boolean
      /**
       * 图片路径
       */
      path?: string
    }[]
    /**
     * 状态(0：草稿(不用)，1：待采用，2：已采用，3：取消采用)
     */
    status?: number
    /**
     * 特性标注
     */
    thirdparty_feature_callout?: {
      /**
       * id
       */
      key?: number
      /**
       * 值
       */
      value?: string
    }[]
    /**
     * 重量（g）
     */
    weight?: number
  }[]
  /**
   * POA尺码/其他
   */
  poa_size?: string
  /**
   * POA尺码类型
   */
  poa_size_type?: number
  /**
   * 参考价格（元）
   */
  price?: number
  /**
   * 供应商产品链接
   */
  product_link?: string
  /**
   * QQ
   */
  qq?: string
  /**
   * 状态(0：草稿，1：待采用，2：已采用，3：取消采用)
   */
  status?: number
  /**
   * 供应商ID
   */
  supplier_id?: number
  /**
   * 新品分类中文
   */
  thirdparty_category_cn_name?: string
  /**
   * 第三方新品分类ID
   */
  thirdparty_category_id?: number
  /**
   * 新品分类英文
   */
  thirdparty_category_name?: string
  /**
   * 第三方服装品类ID
   */
  thirdparty_clothing_category_id?: string
  /**
   * 服装品类
   */
  thirdparty_clothing_category_name?: string
  /**
   * 第三方服装面料弹性ID
   */
  thirdparty_clothing_elasticity_id?: number
  /**
   * 服装面料弹性
   */
  thirdparty_clothing_elasticity_name?: string
  /**
   * 第三方服装二级品类ID
   */
  thirdparty_clothing_second_category_id?: number
  /**
   * 服装二级品类
   */
  thirdparty_clothing_second_category_name?: string
  /**
   * 第三方服装款式ID
   */
  thirdparty_clothing_style_id?: number
  /**
   * 服装款式
   */
  thirdparty_clothing_style_name?: string
  /**
   * 特性标注
   */
  thirdparty_feature_callout?: {
    /**
     * id
     */
    key?: number
    /**
     * 值
     */
    value?: string
  }[]
  /**
   * 第三方ID
   */
  thirdparty_id?: number
  /**
   * 第三方旧产品分类ID
   */
  thirdparty_old_category_id?: number
  /**
   * 旧产品分类
   */
  thirdparty_old_category_name?: string
  /**
   * 第三方电子插头规格ID
   */
  thirdparty_plug_specifications_id?: number
  /**
   * 插头规格
   */
  thirdparty_plug_specifications_name?: string
  /**
   * 四季标签
   */
  thirdparty_season_label_name?: {
    /**
     * id
     */
    key?: number
    /**
     * 值
     */
    value?: string
  }[]
  /**
   * 适用年龄
   */
  thirdparty_suitable_age_name?: {
    /**
     * id
     */
    key?: number
    /**
     * 值
     */
    value?: string
  }[]
  /**
   * 第三方服装服装tag尺码标准ID
   */
  thirdparty_tag_size_id?: number
  /**
   * 服装tag尺码标准
   */
  thirdparty_tag_size_name?: string
  /**
   * 参考重量（g）
   */
  weight?: number
}

/**
 * 接口 添加新品草稿 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/addDraftNewProduct`
 */
export interface AddDraftNewProductResponse {
  code?: number
  errorInfo?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  isAuthorizedRequest?: boolean
  /**
   * 是否返回正确结果
   */
  isSuccess?: boolean
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 正确结果
   */
  result?: string
  /**
   * 报错接口URI
   */
  targetUrl?: string
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 添加新品草稿 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/addDraftNewProduct`
 */
type AddDraftNewProductRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/newProduct/addDraftNewProduct',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 添加新品草稿 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/addDraftNewProduct`
 */
const addDraftNewProductRequestConfig: AddDraftNewProductRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/addDraftNewProduct',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'addDraftNewProduct',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 添加新品草稿 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/addDraftNewProduct`
 */
export const addDraftNewProduct = /*#__PURE__*/ (
  requestData: AddDraftNewProductRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AddDraftNewProductResponse>(prepare(addDraftNewProductRequestConfig, requestData), ...args)
}

addDraftNewProduct.requestConfig = addDraftNewProductRequestConfig

/**
 * 接口 添加新品 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/addNewProduct`
 */
export interface AddNewProductRequest {
  /**
   * 旺旺号
   */
  ali_wangwang?: string
  /**
   * 到货/生产天数
   */
  arrival_days?: number
  /**
   * 新品产品描述
   */
  base_description?: string
  /**
   * 是否能提供整箱配送 0:否 1:能
   */
  box_able?: number
  /**
   * 整箱尺寸高（最短边）
   */
  box_high?: number
  /**
   * 整箱尺寸长(最长边)
   */
  box_length?: number
  /**
   * 整箱个数
   */
  box_num?: number
  /**
   * 整箱重量
   */
  box_weight?: number
  /**
   * 整箱尺寸宽（次长边）
   */
  box_width?: number
  /**
   * 品牌名
   */
  brands_name?: string
  /**
   * 删除的证书id
   */
  certification_ids?: number[]
  /**
   * 产品资料及认证证书
   */
  certification_link?: {
    /**
     * 文件名
     */
    file_name?: string
    /**
     * 文件路径
     */
    file_path?: string
  }[]
  /**
   * 中文名
   */
  chinese_name?: string
  /**
   * 服装面料成分
   */
  clothing_composition_name?: string
  /**
   * 默认图片
   */
  default_img_link?: string
  /**
   * 删除属性ID集合
   */
  del_poa?: number[]
  /**
   * 英文名
   */
  english_name?: string
  /**
   * 其他类属性描述集合
   */
  etc_property_descriptions?: {
    key?: string
    value?: string
  }[]
  /**
   * 推荐类型: 0-普通推新;1-自主上架
   */
  ewd_recommend_type?: number
  /**
   * 预测体积高
   */
  forecast_height?: number
  /**
   * 预测体积长
   */
  forecast_length?: number
  /**
   * 预测体积宽
   */
  forecast_width?: number
  /**
   * 新品ID
   */
  id?: number
  /**
   * 删除的图片id
   */
  img_ids?: number[]
  /**
   * 图片
   */
  img_link?: string[]
  /**
   * 是否转接头
   */
  is_adapter?: boolean
  /**
   * 是否无条件包邮
   */
  is_exemptpostage?: number
  /**
   * 是否显示四季标签，服装特性，适用年龄
   */
  is_show?: boolean
  /**
   * 最小订货量
   */
  min_num?: number
  /**
   * 新品类型(0:电子 1:服装)
   */
  new_product_type?: number
  /**
   * 包装清单描述
   */
  package_description?: {
    /**
     * 配件名称
     */
    name?: string
    /**
     * 数量
     */
    quantity?: string
  }[]
  /**
   * POA颜色
   */
  poa_color?: string
  /**
   * 属性信息
   */
  poa_infos?: {
    /**
     * 到货/生产天数
     */
    arrival_days?: number
    /**
     * 最短边
     */
    box_high?: number
    /**
     * 最长边
     */
    box_length?: number
    /**
     * 次长边
     */
    box_width?: number
    /**
     * ID
     */
    id?: number
    /**
     * 最小订货量
     */
    min_num?: number
    /**
     * POA颜色
     */
    poa_color?: string
    /**
     * POA尺码/其他
     */
    poa_size?: string
    /**
     * POA尺码类型
     */
    poa_size_type?: number
    /**
     * 价格（元）
     */
    price?: number
    /**
     * 属性图片信息
     */
    property_images?: {
      /**
       * 图片Id
       */
      id?: number
      /**
       * 是否默认
       */
      is_default?: boolean
      /**
       * 是否删除
       */
      is_deleted?: boolean
      /**
       * 图片路径
       */
      path?: string
    }[]
    /**
     * 状态(0：草稿(不用)，1：待采用，2：已采用，3：取消采用)
     */
    status?: number
    /**
     * 特性标注
     */
    thirdparty_feature_callout?: {
      /**
       * id
       */
      key?: number
      /**
       * 值
       */
      value?: string
    }[]
    /**
     * 重量（g）
     */
    weight?: number
  }[]
  /**
   * POA尺码/其他
   */
  poa_size?: string
  /**
   * POA尺码类型
   */
  poa_size_type?: number
  /**
   * 参考价格（元）
   */
  price?: number
  /**
   * 供应商产品链接
   */
  product_link?: string
  /**
   * QQ
   */
  qq?: string
  /**
   * 状态(0：草稿，1：待采用，2：已采用，3：取消采用)
   */
  status?: number
  /**
   * 供应商ID
   */
  supplier_id?: number
  /**
   * 新品分类中文
   */
  thirdparty_category_cn_name?: string
  /**
   * 第三方新品分类ID
   */
  thirdparty_category_id?: number
  /**
   * 新品分类英文
   */
  thirdparty_category_name?: string
  /**
   * 第三方服装品类ID
   */
  thirdparty_clothing_category_id?: string
  /**
   * 服装品类
   */
  thirdparty_clothing_category_name?: string
  /**
   * 第三方服装面料弹性ID
   */
  thirdparty_clothing_elasticity_id?: number
  /**
   * 服装面料弹性
   */
  thirdparty_clothing_elasticity_name?: string
  /**
   * 第三方服装二级品类ID
   */
  thirdparty_clothing_second_category_id?: number
  /**
   * 服装二级品类
   */
  thirdparty_clothing_second_category_name?: string
  /**
   * 第三方服装款式ID
   */
  thirdparty_clothing_style_id?: number
  /**
   * 服装款式
   */
  thirdparty_clothing_style_name?: string
  /**
   * 特性标注
   */
  thirdparty_feature_callout?: {
    /**
     * id
     */
    key?: number
    /**
     * 值
     */
    value?: string
  }[]
  /**
   * 第三方ID
   */
  thirdparty_id?: number
  /**
   * 第三方旧产品分类ID
   */
  thirdparty_old_category_id?: number
  /**
   * 旧产品分类
   */
  thirdparty_old_category_name?: string
  /**
   * 第三方电子插头规格ID
   */
  thirdparty_plug_specifications_id?: number
  /**
   * 插头规格
   */
  thirdparty_plug_specifications_name?: string
  /**
   * 四季标签
   */
  thirdparty_season_label_name?: {
    /**
     * id
     */
    key?: number
    /**
     * 值
     */
    value?: string
  }[]
  /**
   * 适用年龄
   */
  thirdparty_suitable_age_name?: {
    /**
     * id
     */
    key?: number
    /**
     * 值
     */
    value?: string
  }[]
  /**
   * 第三方服装服装tag尺码标准ID
   */
  thirdparty_tag_size_id?: number
  /**
   * 服装tag尺码标准
   */
  thirdparty_tag_size_name?: string
  /**
   * 参考重量（g）
   */
  weight?: number
}

/**
 * 接口 添加新品 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/addNewProduct`
 */
export interface AddNewProductResponse {
  code?: number
  errorInfo?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  isAuthorizedRequest?: boolean
  /**
   * 是否返回正确结果
   */
  isSuccess?: boolean
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 正确结果
   */
  result?: string
  /**
   * 报错接口URI
   */
  targetUrl?: string
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 添加新品 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/addNewProduct`
 */
type AddNewProductRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/newProduct/addNewProduct', 'data', string, string, false>
>

/**
 * 接口 添加新品 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/addNewProduct`
 */
const addNewProductRequestConfig: AddNewProductRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/addNewProduct',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'addNewProduct',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 添加新品 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/addNewProduct`
 */
export const addNewProduct = /*#__PURE__*/ (requestData: AddNewProductRequest, ...args: UserRequestRestArgs) => {
  return request<AddNewProductResponse>(prepare(addNewProductRequestConfig, requestData), ...args)
}

addNewProduct.requestConfig = addNewProductRequestConfig

/**
 * 接口 提交审核 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/commitNewProduct`
 */
export interface CommitNewProductRequest {
  /**
   * id
   */
  id: string
}

/**
 * 接口 提交审核 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/commitNewProduct`
 */
export interface CommitNewProductResponse {
  code?: number
  errorInfo?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  isAuthorizedRequest?: boolean
  /**
   * 是否返回正确结果
   */
  isSuccess?: boolean
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 正确结果
   */
  result?: string
  /**
   * 报错接口URI
   */
  targetUrl?: string
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 提交审核 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/commitNewProduct`
 */
type CommitNewProductRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/newProduct/commitNewProduct', 'data', string, 'id', false>
>

/**
 * 接口 提交审核 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/commitNewProduct`
 */
const commitNewProductRequestConfig: CommitNewProductRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/commitNewProduct',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: ['id'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'commitNewProduct',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 提交审核 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/commitNewProduct`
 */
export const commitNewProduct = /*#__PURE__*/ (requestData: CommitNewProductRequest, ...args: UserRequestRestArgs) => {
  return request<CommitNewProductResponse>(prepare(commitNewProductRequestConfig, requestData), ...args)
}

commitNewProduct.requestConfig = commitNewProductRequestConfig

/**
 * 接口 推送到EWD新品 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/commitToScm`
 */
export interface CommitToScmRequest {
  /**
   * id
   */
  id: string
}

/**
 * 接口 推送到EWD新品 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/commitToScm`
 */
export interface CommitToScmResponse {
  code?: number
  errorInfo?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  isAuthorizedRequest?: boolean
  /**
   * 是否返回正确结果
   */
  isSuccess?: boolean
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 正确结果
   */
  result?: string
  /**
   * 报错接口URI
   */
  targetUrl?: string
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 推送到EWD新品 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/commitToScm`
 */
type CommitToScmRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/newProduct/commitToScm', 'data', string, 'id', false>
>

/**
 * 接口 推送到EWD新品 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/commitToScm`
 */
const commitToScmRequestConfig: CommitToScmRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/commitToScm',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: ['id'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'commitToScm',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 推送到EWD新品 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/commitToScm`
 */
export const commitToScm = /*#__PURE__*/ (requestData: CommitToScmRequest, ...args: UserRequestRestArgs) => {
  return request<CommitToScmResponse>(prepare(commitToScmRequestConfig, requestData), ...args)
}

commitToScm.requestConfig = commitToScmRequestConfig

/**
 * 接口 delNewProductDraft 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/delNewProductDraft`
 */
export interface DelNewProductDraftRequest {}

/**
 * 接口 delNewProductDraft 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/delNewProductDraft`
 */
export interface DelNewProductDraftResponse {
  code?: number
  errorInfo?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  isAuthorizedRequest?: boolean
  /**
   * 是否返回正确结果
   */
  isSuccess?: boolean
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 正确结果
   */
  result?: string
  /**
   * 报错接口URI
   */
  targetUrl?: string
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 delNewProductDraft 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/delNewProductDraft`
 */
type DelNewProductDraftRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/newProduct/delNewProductDraft', 'data', string, string, true>
>

/**
 * 接口 delNewProductDraft 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/delNewProductDraft`
 */
const delNewProductDraftRequestConfig: DelNewProductDraftRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/delNewProductDraft',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'delNewProductDraft',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 delNewProductDraft 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/delNewProductDraft`
 */
export const delNewProductDraft = /*#__PURE__*/ (
  requestData?: DelNewProductDraftRequest,
  ...args: UserRequestRestArgs
) => {
  return request<DelNewProductDraftResponse>(prepare(delNewProductDraftRequestConfig, requestData), ...args)
}

delNewProductDraft.requestConfig = delNewProductDraftRequestConfig

/**
 * 接口 获取bg分类信息 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getBgCategoryList`
 */
export interface GetBgCategoryListRequest {
  /**
   * site
   */
  site: string
}

/**
 * 接口 获取bg分类信息 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getBgCategoryList`
 */
export interface GetBgCategoryListResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 正确结果
   */
  result?: {
    /**
     * 分类ID
     */
    categoryid?: number
    /**
     * 中文分类名称
     */
    categoryname?: string
    /**
     * 英文分类名称
     */
    categorynameen?: string
    /**
     * 子节点
     */
    childrens?: unknown[]
    /**
     * 中文分类名称
     */
    cnDescription?: string
    /**
     * meta描述
     */
    metaDescription?: string
    /**
     * meta关键词
     */
    metaKeywords?: string
    /**
     * meta标题
     */
    metaTitle?: string
    /**
     * 上级分类ID
     */
    parentid?: number
    /**
     * 排序
     */
    sortOrder?: number
  }[]
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 获取bg分类信息 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getBgCategoryList`
 */
type GetBgCategoryListRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/newProduct/getBgCategoryList', 'data', string, 'site', false>
>

/**
 * 接口 获取bg分类信息 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getBgCategoryList`
 */
const getBgCategoryListRequestConfig: GetBgCategoryListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/getBgCategoryList',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: ['site'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getBgCategoryList',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 获取bg分类信息 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getBgCategoryList`
 */
export const getBgCategoryList = /*#__PURE__*/ (
  requestData: GetBgCategoryListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GetBgCategoryListResponse>(prepare(getBgCategoryListRequestConfig, requestData), ...args)
}

getBgCategoryList.requestConfig = getBgCategoryListRequestConfig

/**
 * 接口 获取类目信息 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getCategoryFilterList`
 */
export interface GetCategoryFilterListRequest {
  /**
   * site
   */
  site: string
  /**
   * categoryId
   */
  categoryId: string
}

/**
 * 接口 获取类目信息 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getCategoryFilterList`
 */
export interface GetCategoryFilterListResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 正确结果
   */
  result?: {
    baseTagId?: number
    /**
     * IS所属的分类ID
     */
    categoryId?: number
    /**
     * 中文名称
     */
    chineseName?: string
    /**
     * IS值集合
     */
    filterValueVos?: {
      /**
       * 所属的分类ID
       */
      categoryId?: number
      /**
       * 中文名称
       */
      chineseName?: string
      /**
       * IS的ID
       */
      filterId?: number
      /**
       * 是否拥有
       */
      haveSelect?: boolean
      /**
       * ID
       */
      id?: number
      /**
       * 排序
       */
      sortOrder?: number
      /**
       * 值
       */
      value?: string
    }[]
    /**
     * 是否拥有
     */
    haveSelect?: boolean
    /**
     * IS的ID
     */
    id?: number
    /**
     * 名称
     */
    name?: string
    /**
     * 站点
     */
    site?: number
    /**
     * 排序
     */
    sortOrder?: number
    updateUserName?: string
  }[]
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 获取类目信息 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getCategoryFilterList`
 */
type GetCategoryFilterListRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/newProduct/getCategoryFilterList',
    'data',
    string,
    'site' | 'categoryId',
    false
  >
>

/**
 * 接口 获取类目信息 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getCategoryFilterList`
 */
const getCategoryFilterListRequestConfig: GetCategoryFilterListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/getCategoryFilterList',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: ['site', 'categoryId'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getCategoryFilterList',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 获取类目信息 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getCategoryFilterList`
 */
export const getCategoryFilterList = /*#__PURE__*/ (
  requestData: GetCategoryFilterListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GetCategoryFilterListResponse>(prepare(getCategoryFilterListRequestConfig, requestData), ...args)
}

getCategoryFilterList.requestConfig = getCategoryFilterListRequestConfig

/**
 * 接口 是否显示四季标签，服装特性，适用年龄 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/getCategoryFlags`
 */
export interface GetCategoryFlagsRequest {
  /**
   * 旧产品分类ID
   */
  category_id?: number
  /**
   * 旧产品类型（1）
   */
  type?: number
}

/**
 * 接口 是否显示四季标签，服装特性，适用年龄 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/getCategoryFlags`
 */
export interface GetCategoryFlagsResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  result?: {
    /**
     * 是否有年龄限制
     */
    is_age_limited?: boolean
    /**
     * 是否服装特性
     */
    is_clothes_feature?: boolean
    /**
     * 是否电子类
     */
    is_electronic?: boolean
    /**
     * 是否季节相关
     */
    is_seasonal?: boolean
  }
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 是否显示四季标签，服装特性，适用年龄 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/getCategoryFlags`
 */
type GetCategoryFlagsRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/newProduct/getCategoryFlags', 'data', string, string, false>
>

/**
 * 接口 是否显示四季标签，服装特性，适用年龄 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/getCategoryFlags`
 */
const getCategoryFlagsRequestConfig: GetCategoryFlagsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/getCategoryFlags',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getCategoryFlags',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 是否显示四季标签，服装特性，适用年龄 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/getCategoryFlags`
 */
export const getCategoryFlags = /*#__PURE__*/ (requestData: GetCategoryFlagsRequest, ...args: UserRequestRestArgs) => {
  return request<GetCategoryFlagsResponse>(prepare(getCategoryFlagsRequestConfig, requestData), ...args)
}

getCategoryFlags.requestConfig = getCategoryFlagsRequestConfig

/**
 * 接口 新产品分类搜索 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getCategorySearch`
 */
export interface GetCategorySearchRequest {
  /**
   * id
   */
  id?: string
  /**
   * name
   */
  name?: string
}

/**
 * 接口 新产品分类搜索 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getCategorySearch`
 */
export interface GetCategorySearchResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 正确结果
   */
  result?: {
    /**
     * cnName
     */
    cn_name?: string
    /**
     * enName
     */
    en_name?: string
    /**
     * fullId
     */
    full_id?: string
    /**
     * fullName
     */
    full_name?: string
    /**
     * id
     */
    id?: string
    /**
     * isLeaf
     */
    is_leaf?: boolean
    /**
     * isUserDefined
     */
    is_user_defined?: boolean
    leaf?: boolean
    /**
     * level
     */
    level?: number
    /**
     * listOrder
     */
    list_order?: number
    /**
     * parentID
     */
    parent_id?: number
    /**
     * seqNo
     */
    seq_no?: string
    userDefined?: boolean
  }[]
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 新产品分类搜索 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getCategorySearch`
 */
type GetCategorySearchRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/newProduct/getCategorySearch',
    'data',
    string,
    'id' | 'name',
    false
  >
>

/**
 * 接口 新产品分类搜索 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getCategorySearch`
 */
const getCategorySearchRequestConfig: GetCategorySearchRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/getCategorySearch',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: ['id', 'name'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getCategorySearch',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 新产品分类搜索 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getCategorySearch`
 */
export const getCategorySearch = /*#__PURE__*/ (
  requestData: GetCategorySearchRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GetCategorySearchResponse>(prepare(getCategorySearchRequestConfig, requestData), ...args)
}

getCategorySearch.requestConfig = getCategorySearchRequestConfig

/**
 * 接口 获取草稿 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getDraftNewProduct`
 */
export interface GetDraftNewProductRequest {}

/**
 * 接口 获取草稿 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getDraftNewProduct`
 */
export interface GetDraftNewProductResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  result?: {
    adapter?: boolean
    /**
     * 旺旺号
     */
    ali_wangwang?: string
    /**
     * 到货/生产天数
     */
    arrival_days?: number
    /**
     * 附件
     */
    attachment?: {
      /**
       * 附件类型
       */
      attachment_type?: number
      /**
       * 附件名称
       */
      file_name?: string
      /**
       * 附件地址
       */
      file_path?: string
      /**
       * 附件id
       */
      id?: number
    }[]
    /**
     * 是否能提供整箱配送 0：否 1：能
     */
    box_able?: number
    /**
     * 整箱尺寸（高）
     */
    box_high?: number
    /**
     * 整箱尺寸(长)
     */
    box_length?: number
    /**
     * 整箱个数
     */
    box_num?: number
    /**
     * 整箱重量
     */
    box_weight?: number
    /**
     * 整箱尺寸（宽）
     */
    box_width?: number
    /**
     * 品牌
     */
    brands_name?: string
    /**
     * 核查数量
     */
    check_num?: number
    /**
     * 核查价格
     */
    check_price?: number
    /**
     * 核查重量
     */
    check_weight?: number
    /**
     * 中文名
     */
    chinese_name?: string
    /**
     * 服装面料成分
     */
    clothing_composition_name?: string
    /**
     * 创建时间
     */
    create_date?: string
    /**
     * 英文名
     */
    english_name?: string
    /**
     * 主键
     */
    id?: number
    /**
     * 是否转接头
     */
    is_adapter?: boolean
    /**
     * 是否无条件包邮
     */
    is_exemptpostage?: number
    /**
     * POA是否按款项生成(0：待采用，1：已采用，2：取消采用)
     */
    is_section_create?: boolean
    /**
     * 是否显示四季标签，服装特性，适用年龄
     */
    is_show?: boolean
    /**
     * 最小订货量
     */
    min_num?: number
    /**
     * 新品编号
     */
    new_product_code?: string
    /**
     * 新品类型(0:电子 1:服装)
     */
    new_product_type?: number
    /**
     * 付款类型
     */
    payment_type?: number
    /**
     * 新品图片
     */
    picture_url?: {
      /**
       * 主键
       */
      id?: number
      /**
       * 默认图片
       */
      is_default?: number
      /**
       * 图片
       */
      picture_url?: string
      /**
       * 颜色
       */
      poa_color?: string
      /**
       * 尺码
       */
      poa_size?: string
    }[]
    /**
     * POA颜色
     */
    poa_color?: string
    /**
     * POA尺码/其他
     */
    poa_size?: string
    /**
     * POA尺码/其他类型
     */
    poa_size_type?: number
    /**
     * 参考价格（元）
     */
    price?: number
    /**
     * 供应商产品链接
     */
    product_link?: string
    /**
     * QQ
     */
    qq?: string
    /**
     * 审核时间
     */
    review_date?: string
    /**
     * 审核备注
     */
    review_remark?: string
    sectionCreate?: boolean
    show?: boolean
    /**
     * 状态(0：草稿，1：待采用，2：已采用，3：取消采用)
     */
    status?: number
    /**
     * 供应商ID
     */
    supplier_id?: number
    /**
     * 供应商起订量
     */
    supplier_subscribe?: number
    /**
     * 供应链类型
     */
    supply_chain_type?: number
    /**
     * 供货类型
     */
    supply_type?: number
    /**
     * 第三方新品品牌ID
     */
    thirdparty_brands_id?: number
    /**
     * 新品品牌
     */
    thirdparty_brands_name?: string
    /**
     * 第三方新品分类ID
     */
    thirdparty_category_id?: string
    /**
     * 新品分类
     */
    thirdparty_category_name?: string
    /**
     * 第三方服装品类ID
     */
    thirdparty_clothing_category_id?: string
    /**
     * 服装品类
     */
    thirdparty_clothing_category_name?: string
    /**
     * 第三方服装面料弹性ID
     */
    thirdparty_clothing_elasticity_id?: number
    /**
     * 服装面料弹性
     */
    thirdparty_clothing_elasticity_name?: string
    /**
     * 第三方服装二级品类ID
     */
    thirdparty_clothing_second_category_id?: number
    /**
     * 服装二级品类
     */
    thirdparty_clothing_second_category_name?: string
    /**
     * 第三方服装款式ID
     */
    thirdparty_clothing_style_id?: number
    /**
     * 服装款式
     */
    thirdparty_clothing_style_name?: string
    /**
     * 特性标注
     */
    thirdparty_feature_callout?: string
    /**
     * 第三方特性标注ID
     */
    thirdparty_feature_callout_id?: string
    /**
     * 第三方ID
     */
    thirdparty_id?: number
    /**
     * 第三方旧产品分类ID
     */
    thirdparty_old_category_id?: string
    /**
     * 旧产品分类
     */
    thirdparty_old_category_name?: string
    /**
     * 第三方电子插头规格ID
     */
    thirdparty_plug_specifications_id?: number
    /**
     * 插头规格
     */
    thirdparty_plug_specifications_name?: string
    /**
     * 第三方新品SKU
     */
    thirdparty_product_code?: string
    /**
     * 第三方四季标签ID
     */
    thirdparty_season_label_id?: string
    /**
     * 四季标签
     */
    thirdparty_season_label_name?: string
    /**
     * 第三方服装适用年龄ID
     */
    thirdparty_suitable_age_id?: string
    /**
     * 适用年龄
     */
    thirdparty_suitable_age_name?: string
    /**
     * 第三方服装服装tag尺码标准ID
     */
    thirdparty_tag_size_id?: number
    /**
     * 服装tag尺码标准
     */
    thirdparty_tag_size_name?: string
    /**
     * 货期
     */
    time_goods?: number
    /**
     * 参考重量（g）
     */
    weight?: number
  }
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 获取草稿 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getDraftNewProduct`
 */
type GetDraftNewProductRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/newProduct/getDraftNewProduct', 'data', string, string, true>
>

/**
 * 接口 获取草稿 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getDraftNewProduct`
 */
const getDraftNewProductRequestConfig: GetDraftNewProductRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/getDraftNewProduct',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getDraftNewProduct',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 获取草稿 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getDraftNewProduct`
 */
export const getDraftNewProduct = /*#__PURE__*/ (
  requestData?: GetDraftNewProductRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GetDraftNewProductResponse>(prepare(getDraftNewProductRequestConfig, requestData), ...args)
}

getDraftNewProduct.requestConfig = getDraftNewProductRequestConfig

/**
 * 接口 获取图片服务器信息 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getImagesServer`
 */
export interface GetImagesServerRequest {}

/**
 * 接口 获取图片服务器信息 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getImagesServer`
 */
export interface GetImagesServerResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  result?: {
    copy_url?: string
    delete_url?: string
    download_url?: string
    image_size_url?: string
    perm_code?: string
    thumb_url?: string
    upload_url?: string
  }
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 获取图片服务器信息 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getImagesServer`
 */
type GetImagesServerRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/newProduct/getImagesServer', 'data', string, string, true>
>

/**
 * 接口 获取图片服务器信息 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getImagesServer`
 */
const getImagesServerRequestConfig: GetImagesServerRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/getImagesServer',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getImagesServer',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 获取图片服务器信息 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getImagesServer`
 */
export const getImagesServer = /*#__PURE__*/ (requestData?: GetImagesServerRequest, ...args: UserRequestRestArgs) => {
  return request<GetImagesServerResponse>(prepare(getImagesServerRequestConfig, requestData), ...args)
}

getImagesServer.requestConfig = getImagesServerRequestConfig

/**
 * 接口 获得新产品分类 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductCategory`
 */
export interface GetNewProductCategoryRequest {
  /**
   * id
   */
  id?: string
}

/**
 * 接口 获得新产品分类 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductCategory`
 */
export interface GetNewProductCategoryResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 正确结果
   */
  result?: {
    /**
     * categoryCode
     */
    category_code?: string
    /**
     * cnName
     */
    cn_name?: string
    /**
     * colorType
     */
    color_type?: number
    /**
     * enName
     */
    en_name?: string
    /**
     * fullCnName
     */
    full_cn_name?: string
    /**
     * fullId
     */
    full_id?: string
    /**
     * fullName
     */
    full_name?: string
    /**
     * id
     */
    id?: string
    /**
     * isLeaf
     */
    is_leaf?: boolean
    /**
     * isUserDefined
     */
    is_user_defined?: boolean
    /**
     * level
     */
    level?: number
    /**
     * listOrder
     */
    list_order?: number
    /**
     * parentID
     */
    parent_id?: number
    /**
     * parentName
     */
    parent_name?: string
    /**
     * seqNo
     */
    seq_no?: string
  }[]
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 获得新产品分类 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductCategory`
 */
type GetNewProductCategoryRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/newProduct/getNewProductCategory',
    'data',
    string,
    'id',
    false
  >
>

/**
 * 接口 获得新产品分类 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductCategory`
 */
const getNewProductCategoryRequestConfig: GetNewProductCategoryRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/getNewProductCategory',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: ['id'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getNewProductCategory',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 获得新产品分类 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductCategory`
 */
export const getNewProductCategory = /*#__PURE__*/ (
  requestData: GetNewProductCategoryRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GetNewProductCategoryResponse>(prepare(getNewProductCategoryRequestConfig, requestData), ...args)
}

getNewProductCategory.requestConfig = getNewProductCategoryRequestConfig

/**
 * 接口 获取新品详情 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductDetail`
 */
export interface GetNewProductDetailRequest {
  /**
   * id
   */
  id: string
}

/**
 * 接口 获取新品详情 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductDetail`
 */
export interface GetNewProductDetailResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  result?: {
    adapter?: boolean
    /**
     * 旺旺号
     */
    ali_wangwang?: string
    /**
     * 到货/生产天数
     */
    arrival_days?: number
    /**
     * 附件
     */
    attachment?: {
      /**
       * 附件类型
       */
      attachment_type?: number
      /**
       * 附件名称
       */
      file_name?: string
      /**
       * 附件地址
       */
      file_path?: string
      /**
       * 附件id
       */
      id?: number
    }[]
    /**
     * 新品产品描述
     */
    base_description?: string
    /**
     * 是否能提供整箱配送 0：否 1：能
     */
    box_able?: number
    /**
     * 整箱尺寸高（最短边）
     */
    box_high?: number
    /**
     * 整箱尺寸长(最长边)
     */
    box_length?: number
    /**
     * 整箱个数
     */
    box_num?: number
    /**
     * 整箱重量
     */
    box_weight?: number
    /**
     * 整箱尺寸宽（次长边）
     */
    box_width?: number
    /**
     * 品牌
     */
    brands_name?: string
    /**
     * 核查数量
     */
    check_num?: number
    /**
     * 核查价格
     */
    check_price?: number
    /**
     * 核查重量
     */
    check_weight?: number
    /**
     * 中文名
     */
    chinese_name?: string
    /**
     * 服装面料成分
     */
    clothing_composition_name?: string
    /**
     * 创建时间
     */
    create_date?: string
    /**
     * 英文名
     */
    english_name?: string
    /**
     * 其他类属性描述集合
     */
    etc_property_descriptions?: {}[]
    /**
     * 推荐类型: 0-普通推新;1-自主上架
     */
    ewd_recommend_type?: number
    /**
     * 预测体积（高）
     */
    forecast_height?: number
    /**
     * 预测体积(长)
     */
    forecast_length?: number
    /**
     * 预测体积（宽）
     */
    forecast_width?: number
    /**
     * 主键
     */
    id?: number
    /**
     * 是否转接头
     */
    is_adapter?: boolean
    /**
     * 是否无条件包邮
     */
    is_exemptpostage?: number
    /**
     * POA是否按款项生成(0：待采用，1：已采用，2：取消采用)
     */
    is_section_create?: boolean
    /**
     * 是否显示四季标签，服装特性，适用年龄
     */
    is_show?: boolean
    /**
     * 最小订货量
     */
    min_num?: number
    /**
     * 新品编号
     */
    new_product_code?: string
    /**
     * 新品类型(0:电子 1:服装 2：其他)
     */
    new_product_type?: number
    /**
     * 包装清单描述
     */
    package_description?: string
    /**
     * 包装清单描述
     */
    package_descriptions?: {
      /**
       * 配件名称
       */
      name?: string
      /**
       * 数量
       */
      quantity?: number
    }[]
    /**
     * 付款类型
     */
    payment_type?: number
    /**
     * 新品图片
     */
    picture_url?: {
      /**
       * 主键
       */
      id?: number
      /**
       * 默认图片
       */
      is_default?: number
      /**
       * 图片
       */
      picture_url?: string
      /**
       * 颜色
       */
      poa_color?: string
      /**
       * 尺码
       */
      poa_size?: string
    }[]
    /**
     * POA颜色
     */
    poa_color?: string
    /**
     * POA尺码/其他
     */
    poa_size?: string
    /**
     * POA尺码类型
     */
    poa_size_type?: number
    /**
     * 参考价格（元）
     */
    price?: number
    /**
     * 供应商产品链接
     */
    product_link?: string
    /**
     * 属性图片
     */
    property_urls?: {
      /**
       * 主键
       */
      id?: number
      /**
       * 默认图片
       */
      is_default?: number
      /**
       * 图片
       */
      picture_url?: string
      /**
       * 颜色
       */
      poa_color?: string
      /**
       * 尺码
       */
      poa_size?: string
    }[]
    /**
     * QQ
     */
    qq?: string
    /**
     * 审核时间
     */
    review_date?: string
    /**
     * 审核备注
     */
    review_remark?: string
    sectionCreate?: boolean
    /**
     * 上架平台
     */
    shelf_platform?: number
    show?: boolean
    /**
     * 站点类型
     */
    site?: number
    /**
     * 状态(0：草稿，1：待采用，2：已采用，3：取消采用)
     */
    status?: number
    /**
     * 供应商ID
     */
    supplier_id?: number
    /**
     * 供应商起订量
     */
    supplier_subscribe?: number
    /**
     * 供应链类型
     */
    supply_chain_type?: number
    /**
     * 供货类型
     */
    supply_type?: number
    /**
     * 第三方新品品牌ID
     */
    thirdparty_brands_id?: number
    /**
     * 新品品牌
     */
    thirdparty_brands_name?: string
    /**
     * 新品分类中文
     */
    thirdparty_category_cn_name?: string
    /**
     * 第三方新品分类ID
     */
    thirdparty_category_id?: string
    /**
     * 新品分类英文
     */
    thirdparty_category_name?: string
    /**
     * 第三方服装品类ID
     */
    thirdparty_clothing_category_id?: string
    /**
     * 服装品类
     */
    thirdparty_clothing_category_name?: string
    /**
     * 第三方服装面料弹性ID
     */
    thirdparty_clothing_elasticity_id?: number
    /**
     * 服装面料弹性
     */
    thirdparty_clothing_elasticity_name?: string
    /**
     * 第三方服装二级品类ID
     */
    thirdparty_clothing_second_category_id?: number
    /**
     * 服装二级品类
     */
    thirdparty_clothing_second_category_name?: string
    /**
     * 第三方服装款式ID
     */
    thirdparty_clothing_style_id?: number
    /**
     * 服装款式
     */
    thirdparty_clothing_style_name?: string
    /**
     * 特性标注
     */
    thirdparty_feature_callout?: string
    /**
     * 第三方特性标注ID
     */
    thirdparty_feature_callout_id?: string
    /**
     * 第三方ID
     */
    thirdparty_id?: number
    /**
     * 第三方旧产品分类ID
     */
    thirdparty_old_category_id?: string
    /**
     * 旧产品分类
     */
    thirdparty_old_category_name?: string
    /**
     * 第三方电子插头规格ID
     */
    thirdparty_plug_specifications_id?: number
    /**
     * 插头规格
     */
    thirdparty_plug_specifications_name?: string
    /**
     * 第三方新品SKU
     */
    thirdparty_product_code?: string
    /**
     * 第三方四季标签ID
     */
    thirdparty_season_label_id?: string
    /**
     * 四季标签
     */
    thirdparty_season_label_name?: string
    /**
     * 第三方服装适用年龄ID
     */
    thirdparty_suitable_age_id?: string
    /**
     * 适用年龄
     */
    thirdparty_suitable_age_name?: string
    /**
     * 第三方服装服装tag尺码标准ID
     */
    thirdparty_tag_size_id?: number
    /**
     * 服装tag尺码标准
     */
    thirdparty_tag_size_name?: string
    /**
     * 货期
     */
    time_goods?: number
    /**
     * 参考重量（g）
     */
    weight?: number
  }
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 获取新品详情 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductDetail`
 */
type GetNewProductDetailRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/newProduct/getNewProductDetail', 'data', string, 'id', false>
>

/**
 * 接口 获取新品详情 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductDetail`
 */
const getNewProductDetailRequestConfig: GetNewProductDetailRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/getNewProductDetail',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: ['id'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getNewProductDetail',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 获取新品详情 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductDetail`
 */
export const getNewProductDetail = /*#__PURE__*/ (
  requestData: GetNewProductDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GetNewProductDetailResponse>(prepare(getNewProductDetailRequestConfig, requestData), ...args)
}

getNewProductDetail.requestConfig = getNewProductDetailRequestConfig

/**
 * 接口 获取特性标注 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductFeatureLabels`
 */
export interface GetNewProductFeatureLabelsRequest {}

/**
 * 接口 获取特性标注 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductFeatureLabels`
 */
export interface GetNewProductFeatureLabelsResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 正确结果
   */
  result?: {
    /**
     * 大分类id
     */
    category_id?: number
    /**
     * 大分类名
     */
    category_name?: string
    /**
     * 特性详情
     */
    label_items?: {
      /**
       * added_time
       */
      added_time?: string
      /**
       * label_id
       */
      label_id?: number
      /**
       * label_name
       */
      label_name?: string
      /**
       * new_add
       */
      new_add?: boolean
      /**
       * type
       */
      type?: number
    }[]
  }[]
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 获取特性标注 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductFeatureLabels`
 */
type GetNewProductFeatureLabelsRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/newProduct/getNewProductFeatureLabels',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 获取特性标注 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductFeatureLabels`
 */
const getNewProductFeatureLabelsRequestConfig: GetNewProductFeatureLabelsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/getNewProductFeatureLabels',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getNewProductFeatureLabels',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 获取特性标注 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductFeatureLabels`
 */
export const getNewProductFeatureLabels = /*#__PURE__*/ (
  requestData?: GetNewProductFeatureLabelsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GetNewProductFeatureLabelsResponse>(
    prepare(getNewProductFeatureLabelsRequestConfig, requestData),
    ...args,
  )
}

getNewProductFeatureLabels.requestConfig = getNewProductFeatureLabelsRequestConfig

/**
 * 接口 获得旧产品分类 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductOldCategory`
 */
export interface GetNewProductOldCategoryRequest {
  /**
   * id
   */
  id: string
}

/**
 * 接口 获得旧产品分类 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductOldCategory`
 */
export interface GetNewProductOldCategoryResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  result?: {
    /**
     * 中文fullname
     */
    category_cn_full_name?: string
    /**
     * categoryFullId
     */
    category_full_id?: string
    /**
     * fullName
     */
    full_name?: string
    /**
     * mappingList
     */
    mapping_list?: {
      /**
       * categoryCnFullName
       */
      category_cn_full_name?: string
      /**
       * categoryCnName
       */
      category_cn_name?: string
      /**
       * categoryEnFullName
       */
      category_en_full_name?: string
      /**
       * categoryEnName
       */
      category_en_name?: string
      /**
       * categoryId
       */
      category_id?: string
      /**
       * chances
       */
      chances?: number
      /**
       * ebayukCateCnFullName
       */
      ebayuk_cate_cn_full_name?: string
      /**
       * ebayukCateCnName
       */
      ebayuk_cate_cn_name?: string
      /**
       * ebayukCateEnFullName
       */
      ebayuk_cate_en_full_name?: string
      /**
       * ebayukCateEnName
       */
      ebayuk_cate_en_name?: string
      /**
       * ebayukCateId
       */
      ebayuk_cate_id?: string
      /**
       * fixType
       */
      fix_type?: number
      /**
       * id
       */
      id?: number
    }[]
  }
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 获得旧产品分类 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductOldCategory`
 */
type GetNewProductOldCategoryRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/newProduct/getNewProductOldCategory',
    'data',
    string,
    'id',
    false
  >
>

/**
 * 接口 获得旧产品分类 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductOldCategory`
 */
const getNewProductOldCategoryRequestConfig: GetNewProductOldCategoryRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/getNewProductOldCategory',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: ['id'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getNewProductOldCategory',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 获得旧产品分类 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductOldCategory`
 */
export const getNewProductOldCategory = /*#__PURE__*/ (
  requestData: GetNewProductOldCategoryRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GetNewProductOldCategoryResponse>(prepare(getNewProductOldCategoryRequestConfig, requestData), ...args)
}

getNewProductOldCategory.requestConfig = getNewProductOldCategoryRequestConfig

/**
 * 接口 getNewProductStatus 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductStatus`
 */
export interface GetNewProductStatusRequest {}

/**
 * 接口 getNewProductStatus 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductStatus`
 */
export interface GetNewProductStatusResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 正确结果
   */
  result?: {
    /**
     * 保存值
     */
    key?: number
    /**
     * 显示值
     */
    value?: string
  }[]
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 getNewProductStatus 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductStatus`
 */
type GetNewProductStatusRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/newProduct/getNewProductStatus',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 getNewProductStatus 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductStatus`
 */
const getNewProductStatusRequestConfig: GetNewProductStatusRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/getNewProductStatus',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getNewProductStatus',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 getNewProductStatus 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductStatus`
 */
export const getNewProductStatus = /*#__PURE__*/ (
  requestData?: GetNewProductStatusRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GetNewProductStatusResponse>(prepare(getNewProductStatusRequestConfig, requestData), ...args)
}

getNewProductStatus.requestConfig = getNewProductStatusRequestConfig

/**
 * 接口 获取新品类型值 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductType`
 */
export interface GetNewProductTypeRequest {}

/**
 * 接口 获取新品类型值 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductType`
 */
export interface GetNewProductTypeResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 正确结果
   */
  result?: {
    /**
     * 键
     */
    key?: number
    /**
     * 值
     */
    value?: string
  }[]
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 获取新品类型值 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductType`
 */
type GetNewProductTypeRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/newProduct/getNewProductType', 'data', string, string, true>
>

/**
 * 接口 获取新品类型值 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductType`
 */
const getNewProductTypeRequestConfig: GetNewProductTypeRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/getNewProductType',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getNewProductType',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 获取新品类型值 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductType`
 */
export const getNewProductType = /*#__PURE__*/ (
  requestData?: GetNewProductTypeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GetNewProductTypeResponse>(prepare(getNewProductTypeRequestConfig, requestData), ...args)
}

getNewProductType.requestConfig = getNewProductTypeRequestConfig

/**
 * 接口 获取产品对应类型属性 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductTypeLabels`
 */
export interface GetNewProductTypeLabelsRequest {
  /**
   * id
   */
  id: string
}

/**
 * 接口 获取产品对应类型属性 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductTypeLabels`
 */
export interface GetNewProductTypeLabelsResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  result?: {
    /**
     * 品类
     */
    clothing_category?: {
      /**
       * 一级key
       */
      key?: string
      /**
       * 一级名称
       */
      value?: string
    }[]
    /**
     * 款式
     */
    clothing_style?: {
      /**
       * 键
       */
      key?: number
      /**
       * 值
       */
      value?: string
    }[]
    /**
     * 服装tag尺码标准
     */
    clothing_tag_size?: {
      /**
       * 键
       */
      key?: number
      /**
       * 值
       */
      value?: string
    }[]
    /**
     * 面料弹性
     */
    fabric_elasticity?: {
      /**
       * 键
       */
      key?: number
      /**
       * 值
       */
      value?: string
    }[]
    /**
     * 适用年龄
     */
    fit_age?: {
      /**
       * 键
       */
      key?: number
      /**
       * 值
       */
      value?: string
    }[]
    /**
     * 插头规格
     */
    plug_specifications?: {
      /**
       * 键
       */
      key?: number
      /**
       * 值
       */
      value?: string
    }[]
  }
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 获取产品对应类型属性 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductTypeLabels`
 */
type GetNewProductTypeLabelsRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/newProduct/getNewProductTypeLabels',
    'data',
    string,
    'id',
    false
  >
>

/**
 * 接口 获取产品对应类型属性 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductTypeLabels`
 */
const getNewProductTypeLabelsRequestConfig: GetNewProductTypeLabelsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/getNewProductTypeLabels',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: ['id'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getNewProductTypeLabels',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 获取产品对应类型属性 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewProductTypeLabels`
 */
export const getNewProductTypeLabels = /*#__PURE__*/ (
  requestData: GetNewProductTypeLabelsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GetNewProductTypeLabelsResponse>(prepare(getNewProductTypeLabelsRequestConfig, requestData), ...args)
}

getNewProductTypeLabels.requestConfig = getNewProductTypeLabelsRequestConfig

/**
 * 接口 获取最近一次新品详情 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewestProductDetail`
 */
export interface GetNewestProductDetailRequest {}

/**
 * 接口 获取最近一次新品详情 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewestProductDetail`
 */
export interface GetNewestProductDetailResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  result?: {
    adapter?: boolean
    /**
     * 旺旺号
     */
    ali_wangwang?: string
    /**
     * 到货/生产天数
     */
    arrival_days?: number
    /**
     * 附件
     */
    attachment?: {
      /**
       * 附件类型
       */
      attachment_type?: number
      /**
       * 附件名称
       */
      file_name?: string
      /**
       * 附件地址
       */
      file_path?: string
      /**
       * 附件id
       */
      id?: number
    }[]
    /**
     * 新品产品描述
     */
    base_description?: string
    /**
     * 是否能提供整箱配送 0：否 1：能
     */
    box_able?: number
    /**
     * 整箱尺寸高（最短边）
     */
    box_high?: number
    /**
     * 整箱尺寸长(最长边)
     */
    box_length?: number
    /**
     * 整箱个数
     */
    box_num?: number
    /**
     * 整箱重量
     */
    box_weight?: number
    /**
     * 整箱尺寸宽（次长边）
     */
    box_width?: number
    /**
     * 品牌
     */
    brands_name?: string
    /**
     * 核查数量
     */
    check_num?: number
    /**
     * 核查价格
     */
    check_price?: number
    /**
     * 核查重量
     */
    check_weight?: number
    /**
     * 中文名
     */
    chinese_name?: string
    /**
     * 服装面料成分
     */
    clothing_composition_name?: string
    /**
     * 创建时间
     */
    create_date?: string
    /**
     * 英文名
     */
    english_name?: string
    /**
     * 其他类属性描述集合
     */
    etc_property_descriptions?: {}[]
    /**
     * 推荐类型: 0-普通推新;1-自主上架
     */
    ewd_recommend_type?: number
    /**
     * 预测体积（高）
     */
    forecast_height?: number
    /**
     * 预测体积(长)
     */
    forecast_length?: number
    /**
     * 预测体积（宽）
     */
    forecast_width?: number
    /**
     * 主键
     */
    id?: number
    /**
     * 是否转接头
     */
    is_adapter?: boolean
    /**
     * 是否无条件包邮
     */
    is_exemptpostage?: number
    /**
     * POA是否按款项生成(0：待采用，1：已采用，2：取消采用)
     */
    is_section_create?: boolean
    /**
     * 是否显示四季标签，服装特性，适用年龄
     */
    is_show?: boolean
    /**
     * 最小订货量
     */
    min_num?: number
    /**
     * 新品编号
     */
    new_product_code?: string
    /**
     * 新品类型(0:电子 1:服装 2：其他)
     */
    new_product_type?: number
    /**
     * 包装清单描述
     */
    package_description?: string
    /**
     * 包装清单描述
     */
    package_descriptions?: {
      /**
       * 配件名称
       */
      name?: string
      /**
       * 数量
       */
      quantity?: number
    }[]
    /**
     * 付款类型
     */
    payment_type?: number
    /**
     * 新品图片
     */
    picture_url?: {
      /**
       * 主键
       */
      id?: number
      /**
       * 默认图片
       */
      is_default?: number
      /**
       * 图片
       */
      picture_url?: string
      /**
       * 颜色
       */
      poa_color?: string
      /**
       * 尺码
       */
      poa_size?: string
    }[]
    /**
     * POA颜色
     */
    poa_color?: string
    /**
     * POA尺码/其他
     */
    poa_size?: string
    /**
     * POA尺码类型
     */
    poa_size_type?: number
    /**
     * 参考价格（元）
     */
    price?: number
    /**
     * 供应商产品链接
     */
    product_link?: string
    /**
     * 属性图片
     */
    property_urls?: {
      /**
       * 主键
       */
      id?: number
      /**
       * 默认图片
       */
      is_default?: number
      /**
       * 图片
       */
      picture_url?: string
      /**
       * 颜色
       */
      poa_color?: string
      /**
       * 尺码
       */
      poa_size?: string
    }[]
    /**
     * QQ
     */
    qq?: string
    /**
     * 审核时间
     */
    review_date?: string
    /**
     * 审核备注
     */
    review_remark?: string
    sectionCreate?: boolean
    /**
     * 上架平台
     */
    shelf_platform?: number
    show?: boolean
    /**
     * 站点类型
     */
    site?: number
    /**
     * 状态(0：草稿，1：待采用，2：已采用，3：取消采用)
     */
    status?: number
    /**
     * 供应商ID
     */
    supplier_id?: number
    /**
     * 供应商起订量
     */
    supplier_subscribe?: number
    /**
     * 供应链类型
     */
    supply_chain_type?: number
    /**
     * 供货类型
     */
    supply_type?: number
    /**
     * 第三方新品品牌ID
     */
    thirdparty_brands_id?: number
    /**
     * 新品品牌
     */
    thirdparty_brands_name?: string
    /**
     * 新品分类中文
     */
    thirdparty_category_cn_name?: string
    /**
     * 第三方新品分类ID
     */
    thirdparty_category_id?: string
    /**
     * 新品分类英文
     */
    thirdparty_category_name?: string
    /**
     * 第三方服装品类ID
     */
    thirdparty_clothing_category_id?: string
    /**
     * 服装品类
     */
    thirdparty_clothing_category_name?: string
    /**
     * 第三方服装面料弹性ID
     */
    thirdparty_clothing_elasticity_id?: number
    /**
     * 服装面料弹性
     */
    thirdparty_clothing_elasticity_name?: string
    /**
     * 第三方服装二级品类ID
     */
    thirdparty_clothing_second_category_id?: number
    /**
     * 服装二级品类
     */
    thirdparty_clothing_second_category_name?: string
    /**
     * 第三方服装款式ID
     */
    thirdparty_clothing_style_id?: number
    /**
     * 服装款式
     */
    thirdparty_clothing_style_name?: string
    /**
     * 特性标注
     */
    thirdparty_feature_callout?: string
    /**
     * 第三方特性标注ID
     */
    thirdparty_feature_callout_id?: string
    /**
     * 第三方ID
     */
    thirdparty_id?: number
    /**
     * 第三方旧产品分类ID
     */
    thirdparty_old_category_id?: string
    /**
     * 旧产品分类
     */
    thirdparty_old_category_name?: string
    /**
     * 第三方电子插头规格ID
     */
    thirdparty_plug_specifications_id?: number
    /**
     * 插头规格
     */
    thirdparty_plug_specifications_name?: string
    /**
     * 第三方新品SKU
     */
    thirdparty_product_code?: string
    /**
     * 第三方四季标签ID
     */
    thirdparty_season_label_id?: string
    /**
     * 四季标签
     */
    thirdparty_season_label_name?: string
    /**
     * 第三方服装适用年龄ID
     */
    thirdparty_suitable_age_id?: string
    /**
     * 适用年龄
     */
    thirdparty_suitable_age_name?: string
    /**
     * 第三方服装服装tag尺码标准ID
     */
    thirdparty_tag_size_id?: number
    /**
     * 服装tag尺码标准
     */
    thirdparty_tag_size_name?: string
    /**
     * 货期
     */
    time_goods?: number
    /**
     * 参考重量（g）
     */
    weight?: number
  }
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 获取最近一次新品详情 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewestProductDetail`
 */
type GetNewestProductDetailRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/newProduct/getNewestProductDetail',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 获取最近一次新品详情 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewestProductDetail`
 */
const getNewestProductDetailRequestConfig: GetNewestProductDetailRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/getNewestProductDetail',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getNewestProductDetail',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 获取最近一次新品详情 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getNewestProductDetail`
 */
export const getNewestProductDetail = /*#__PURE__*/ (
  requestData?: GetNewestProductDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GetNewestProductDetailResponse>(prepare(getNewestProductDetailRequestConfig, requestData), ...args)
}

getNewestProductDetail.requestConfig = getNewestProductDetailRequestConfig

/**
 * 接口 根据末级产品分类id获取属性参数填写字段 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getProductCategoryParamFileds`
 */
export interface GetProductCategoryParamFiledsRequest {
  /**
   * cateId
   */
  cateId: string
}

/**
 * 接口 根据末级产品分类id获取属性参数填写字段 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getProductCategoryParamFileds`
 */
export interface GetProductCategoryParamFiledsResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 正确结果
   */
  result?: {
    /**
     * 末级品类ID
     */
    cate_id?: number
    /**
     * 参数ID
     */
    param_id?: number
    /**
     * 参数名
     */
    param_name?: string
    /**
     * 是否必填
     */
    required?: boolean
  }[]
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 根据末级产品分类id获取属性参数填写字段 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getProductCategoryParamFileds`
 */
type GetProductCategoryParamFiledsRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/newProduct/getProductCategoryParamFileds',
    'data',
    string,
    'cateId',
    false
  >
>

/**
 * 接口 根据末级产品分类id获取属性参数填写字段 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getProductCategoryParamFileds`
 */
const getProductCategoryParamFiledsRequestConfig: GetProductCategoryParamFiledsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/getProductCategoryParamFileds',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: ['cateId'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getProductCategoryParamFileds',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 根据末级产品分类id获取属性参数填写字段 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getProductCategoryParamFileds`
 */
export const getProductCategoryParamFileds = /*#__PURE__*/ (
  requestData: GetProductCategoryParamFiledsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GetProductCategoryParamFiledsResponse>(
    prepare(getProductCategoryParamFiledsRequestConfig, requestData),
    ...args,
  )
}

getProductCategoryParamFileds.requestConfig = getProductCategoryParamFiledsRequestConfig

/**
 * 接口 获取四季标签 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getSeasonLabel`
 */
export interface GetSeasonLabelRequest {}

/**
 * 接口 获取四季标签 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getSeasonLabel`
 */
export interface GetSeasonLabelResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 正确结果
   */
  result?: {
    /**
     * 键
     */
    key?: number
    /**
     * 值
     */
    value?: string
  }[]
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 获取四季标签 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getSeasonLabel`
 */
type GetSeasonLabelRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/newProduct/getSeasonLabel', 'data', string, string, true>
>

/**
 * 接口 获取四季标签 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getSeasonLabel`
 */
const getSeasonLabelRequestConfig: GetSeasonLabelRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/getSeasonLabel',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getSeasonLabel',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 获取四季标签 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getSeasonLabel`
 */
export const getSeasonLabel = /*#__PURE__*/ (requestData?: GetSeasonLabelRequest, ...args: UserRequestRestArgs) => {
  return request<GetSeasonLabelResponse>(prepare(getSeasonLabelRequestConfig, requestData), ...args)
}

getSeasonLabel.requestConfig = getSeasonLabelRequestConfig

/**
 * 接口 获得二级服装品类 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getSecondClothingCategory`
 */
export interface GetSecondClothingCategoryRequest {
  /**
   * key
   */
  key: string
}

/**
 * 接口 获得二级服装品类 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getSecondClothingCategory`
 */
export interface GetSecondClothingCategoryResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 正确结果
   */
  result?: {
    /**
     * 键
     */
    key?: number
    /**
     * 值
     */
    value?: string
  }[]
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 获得二级服装品类 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getSecondClothingCategory`
 */
type GetSecondClothingCategoryRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/newProduct/getSecondClothingCategory',
    'data',
    string,
    'key',
    false
  >
>

/**
 * 接口 获得二级服装品类 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getSecondClothingCategory`
 */
const getSecondClothingCategoryRequestConfig: GetSecondClothingCategoryRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/getSecondClothingCategory',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: ['key'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getSecondClothingCategory',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 获得二级服装品类 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getSecondClothingCategory`
 */
export const getSecondClothingCategory = /*#__PURE__*/ (
  requestData: GetSecondClothingCategoryRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GetSecondClothingCategoryResponse>(
    prepare(getSecondClothingCategoryRequestConfig, requestData),
    ...args,
  )
}

getSecondClothingCategory.requestConfig = getSecondClothingCategoryRequestConfig

/**
 * 接口 获取供应商还能推本月还能推荐多少新品 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getSupplierNewProductLimit`
 */
export interface GetSupplierNewProductLimitRequest {}

/**
 * 接口 获取供应商还能推本月还能推荐多少新品 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getSupplierNewProductLimit`
 */
export interface GetSupplierNewProductLimitResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  result?: {
    /**
     * 剩余数
     */
    limit?: number
    /**
     * 推荐数
     */
    num?: number
  }
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 获取供应商还能推本月还能推荐多少新品 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getSupplierNewProductLimit`
 */
type GetSupplierNewProductLimitRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/newProduct/getSupplierNewProductLimit',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 获取供应商还能推本月还能推荐多少新品 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getSupplierNewProductLimit`
 */
const getSupplierNewProductLimitRequestConfig: GetSupplierNewProductLimitRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/getSupplierNewProductLimit',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getSupplierNewProductLimit',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 获取供应商还能推本月还能推荐多少新品 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getSupplierNewProductLimit`
 */
export const getSupplierNewProductLimit = /*#__PURE__*/ (
  requestData?: GetSupplierNewProductLimitRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GetSupplierNewProductLimitResponse>(
    prepare(getSupplierNewProductLimitRequestConfig, requestData),
    ...args,
  )
}

getSupplierNewProductLimit.requestConfig = getSupplierNewProductLimitRequestConfig

/**
 * 接口 获取供应商信息 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getSupplierWangwangAndQq`
 */
export interface GetSupplierWangwangAndQqRequest {}

/**
 * 接口 获取供应商信息 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getSupplierWangwangAndQq`
 */
export interface GetSupplierWangwangAndQqResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  result?: {
    /**
     * 阿里旺旺
     */
    ali_wang_wang?: string
    /**
     * qq
     */
    qq?: string
  }
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 获取供应商信息 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getSupplierWangwangAndQq`
 */
type GetSupplierWangwangAndQqRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/newProduct/getSupplierWangwangAndQq',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 获取供应商信息 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getSupplierWangwangAndQq`
 */
const getSupplierWangwangAndQqRequestConfig: GetSupplierWangwangAndQqRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/getSupplierWangwangAndQq',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getSupplierWangwangAndQq',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 获取供应商信息 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getSupplierWangwangAndQq`
 */
export const getSupplierWangwangAndQq = /*#__PURE__*/ (
  requestData?: GetSupplierWangwangAndQqRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GetSupplierWangwangAndQqResponse>(prepare(getSupplierWangwangAndQqRequestConfig, requestData), ...args)
}

getSupplierWangwangAndQq.requestConfig = getSupplierWangwangAndQqRequestConfig

/**
 * 接口 获取变量组信息 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getVariationList`
 */
export interface GetVariationListRequest {
  /**
   * site
   */
  site: string
  /**
   * categoryId
   */
  categoryId: string
}

/**
 * 接口 获取变量组信息 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getVariationList`
 */
export interface GetVariationListResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 正确结果
   */
  result?: {
    /**
     * 变量所属的分类ID
     */
    categoryId?: number
    /**
     * 中文名称
     */
    chineseDescription?: string
    /**
     * 名称
     */
    description?: string
    /**
     * 是否拥有
     */
    haveSelect?: boolean
    /**
     * 变量的ID
     */
    id?: number
    site?: number
    /**
     * 变量值
     */
    variationValueVos?: {
      categoryId?: number
      /**
       * 中文名称
       */
      chineseDescription?: string
      /**
       * 值
       */
      description?: string
      /**
       * 是否拥有
       */
      haveSelect?: boolean
      /**
       * ID
       */
      id?: number
      /**
       * IS的ID
       */
      variationId?: number
    }[]
  }[]
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 获取变量组信息 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getVariationList`
 */
type GetVariationListRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/newProduct/getVariationList',
    'data',
    string,
    'site' | 'categoryId',
    false
  >
>

/**
 * 接口 获取变量组信息 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getVariationList`
 */
const getVariationListRequestConfig: GetVariationListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/getVariationList',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: ['site', 'categoryId'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getVariationList',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 获取变量组信息 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getVariationList`
 */
export const getVariationList = /*#__PURE__*/ (requestData: GetVariationListRequest, ...args: UserRequestRestArgs) => {
  return request<GetVariationListResponse>(prepare(getVariationListRequestConfig, requestData), ...args)
}

getVariationList.requestConfig = getVariationListRequestConfig

/**
 * 接口 获取变量值息 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getVariationValueList`
 */
export interface GetVariationValueListRequest {
  /**
   * site
   */
  site: string
  /**
   * categoryId
   */
  categoryId: string
  /**
   * variationId
   */
  variationId: string
}

/**
 * 接口 获取变量值息 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getVariationValueList`
 */
export interface GetVariationValueListResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  result?: {
    /**
     * 变量所属的分类ID
     */
    categoryId?: number
    /**
     * 中文名称
     */
    chineseDescription?: string
    /**
     * 名称
     */
    description?: string
    /**
     * 是否拥有
     */
    haveSelect?: boolean
    /**
     * 变量的ID
     */
    id?: number
    site?: number
    /**
     * 变量值
     */
    variationValueVos?: {
      categoryId?: number
      /**
       * 中文名称
       */
      chineseDescription?: string
      /**
       * 值
       */
      description?: string
      /**
       * 是否拥有
       */
      haveSelect?: boolean
      /**
       * ID
       */
      id?: number
      /**
       * IS的ID
       */
      variationId?: number
    }[]
  }
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 获取变量值息 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getVariationValueList`
 */
type GetVariationValueListRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/newProduct/getVariationValueList',
    'data',
    string,
    'site' | 'categoryId' | 'variationId',
    false
  >
>

/**
 * 接口 获取变量值息 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getVariationValueList`
 */
const getVariationValueListRequestConfig: GetVariationValueListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/getVariationValueList',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: ['site', 'categoryId', 'variationId'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getVariationValueList',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 获取变量值息 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `GET /newProduct/getVariationValueList`
 */
export const getVariationValueList = /*#__PURE__*/ (
  requestData: GetVariationValueListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GetVariationValueListResponse>(prepare(getVariationValueListRequestConfig, requestData), ...args)
}

getVariationValueList.requestConfig = getVariationValueListRequestConfig

/**
 * 接口 提交新品属性智能识别 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/propertyParamTextAnalyze`
 */
export type PropertyParamTextAnalyzeRequest = string

/**
 * 接口 提交新品属性智能识别 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/propertyParamTextAnalyze`
 */
export interface PropertyParamTextAnalyzeResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 正确结果
   */
  result?: {}[]
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 提交新品属性智能识别 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/propertyParamTextAnalyze`
 */
type PropertyParamTextAnalyzeRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/newProduct/propertyParamTextAnalyze',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 提交新品属性智能识别 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/propertyParamTextAnalyze`
 */
const propertyParamTextAnalyzeRequestConfig: PropertyParamTextAnalyzeRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/propertyParamTextAnalyze',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'propertyParamTextAnalyze',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 提交新品属性智能识别 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/propertyParamTextAnalyze`
 */
export const propertyParamTextAnalyze = /*#__PURE__*/ (
  requestData: PropertyParamTextAnalyzeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PropertyParamTextAnalyzeResponse>(prepare(propertyParamTextAnalyzeRequestConfig, requestData), ...args)
}

propertyParamTextAnalyze.requestConfig = propertyParamTextAnalyzeRequestConfig

/**
 * 接口 新品列表查询 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/searchNewProduct`
 */
export interface SearchNewProductRequest {
  /**
   * 审核时间开始
   */
  begin_review_date?: string
  /**
   * 添加时间开始
   */
  create_begin_date?: string
  /**
   * 添加时间结束
   */
  create_end_date?: string
  /**
   * 审核时间结束
   */
  end_review_date?: string
  /**
   * 产品名称
   */
  name?: string
  /**
   * 当前页
   */
  page_index?: number
  /**
   * 每页显示数量
   */
  page_size?: number
  /**
   * 上架状态 1-待补充上架信息；2-已上架; 3-已补充
   */
  shelf_status?: number
  /**
   * 排序的字段
   */
  sort_field?: number
  /**
   * 排序方式:true:升序;false:降序, 默认倒序
   */
  sort_order?: boolean
  /**
   * 采用状态 0-待提交（草稿）1-待采用 2-已采用 3-取消采用 4-待补充
   */
  status?: number
}

/**
 * 接口 新品列表查询 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/searchNewProduct`
 */
export interface SearchNewProductResponse {
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  result?: {
    /**
     * 列表信息
     */
    items?: {
      /**
       * 到货/生产天数
       */
      arrival_days?: number
      /**
       * 中文名
       */
      chinese_name?: string
      /**
       * POA颜色
       */
      color?: string
      /**
       * 提交次数
       */
      commit_times?: number
      /**
       * 添加时间
       */
      create_date?: string
      /**
       * 英文名
       */
      english_name?: string
      /**
       * 推荐类型: 0-普通推新;1-自主上架
       */
      ewd_recommend_type?: number
      /**
       * 是否含有POA
       */
      has_poa?: boolean
      /**
       * 主键
       */
      id?: number
      /**
       * 最小订货量
       */
      min_num?: number
      /**
       * 产品图片
       */
      picture_url?: string
      /**
       * 参考价格（元）
       */
      price?: number
      /**
       * 审核时间
       */
      review_date?: string
      /**
       * 审核备注
       */
      review_remark?: string
      /**
       * 上架时间
       */
      shelf_date?: string
      /**
       * 上架状态 1-待补充；2 已上架；3-已补充
       */
      shelf_status?: number
      /**
       * POA尺码/其他
       */
      size?: string
      /**
       * 状态(0：草稿，1：待采用，2：已采用，3：取消采用)
       */
      status?: 'DRAFT' | 'BE_ADOPTED' | 'ADOPTED' | 'ABOLISH_ADOPTED' | 'TO_FINISHED'
      /**
       * sku
       */
      thirdparty_product_code?: string
    }[]
    /**
     * 数据总条数
     */
    total_count?: number
  }
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 新品列表查询 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/searchNewProduct`
 */
type SearchNewProductRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/newProduct/searchNewProduct', 'data', string, string, false>
>

/**
 * 接口 新品列表查询 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/searchNewProduct`
 */
const searchNewProductRequestConfig: SearchNewProductRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/searchNewProduct',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'searchNewProduct',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 新品列表查询 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/searchNewProduct`
 */
export const searchNewProduct = /*#__PURE__*/ (requestData: SearchNewProductRequest, ...args: UserRequestRestArgs) => {
  return request<SearchNewProductResponse>(prepare(searchNewProductRequestConfig, requestData), ...args)
}

searchNewProduct.requestConfig = searchNewProductRequestConfig

/**
 * 接口 补充上架信息 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/supplementShelfInfo`
 */
export interface SupplementShelfInfoRequest {
  /**
   * 分类全路径Id
   */
  category_full_path_id?: string[]
  /**
   * 类目信息
   */
  category_specifications: {
    /**
     * 类目组Id
     */
    id?: number
    /**
     * 类目组值
     */
    name?: string
    /**
     * 类目值信息
     */
    values?: {
      /**
       * 类目值Id
       */
      id?: number
      /**
       * 类目值名称
       */
      name?: string
    }[]
  }[]
  /**
   * 产品描述 富文本
   */
  descriptions_html: string
  /**
   * 英文图片
   */
  en_images?: {
    /**
     * 图片路径
     */
    image: string
  }[]
  /**
   * 商品图片
   */
  images: {
    /**
     * 图片路径
     */
    image: string
  }[]
  /**
   * 新品Id
   */
  new_product_id: number
  /**
   * 产品编码不为空
   */
  product_code: string
  /**
   * 商品副标题
   */
  sub_title?: string
  /**
   * 商品标题
   */
  title: string
  /**
   * 商品视频链接
   */
  video_url?: string
}

/**
 * 接口 补充上架信息 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/supplementShelfInfo`
 */
export interface SupplementShelfInfoResponse {
  code?: number
  errorInfo?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  isAuthorizedRequest?: boolean
  /**
   * 是否返回正确结果
   */
  isSuccess?: boolean
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 正确结果
   */
  result?: string
  /**
   * 报错接口URI
   */
  targetUrl?: string
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 补充上架信息 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/supplementShelfInfo`
 */
type SupplementShelfInfoRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/newProduct/supplementShelfInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 补充上架信息 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/supplementShelfInfo`
 */
const supplementShelfInfoRequestConfig: SupplementShelfInfoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/supplementShelfInfo',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'supplementShelfInfo',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 补充上架信息 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/supplementShelfInfo`
 */
export const supplementShelfInfo = /*#__PURE__*/ (
  requestData: SupplementShelfInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<SupplementShelfInfoResponse>(prepare(supplementShelfInfoRequestConfig, requestData), ...args)
}

supplementShelfInfo.requestConfig = supplementShelfInfoRequestConfig

/**
 * 接口 翻译接口 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/translation`
 */
export interface TranslationRequest {
  /**
   * 翻译文本
   */
  content?: string
  /**
   * 源语言代码，EN-英语;ZHCN-中文;PL-波兰语;DL-荷兰语;RU-俄语;FR-法语;DE-德语;ES-西班牙语;IT-意大利语;JA-日语; = ['EN', 'ZHCN', 'PL', 'DL', 'RU', 'FR', 'DE', 'ES', 'IT', 'JA']
   */
  from_code?: string
  /**
   * 目标语言代码，EN-英语;ZHCN-中文;PL-波兰语;DL-荷兰语;RU-俄语;FR-法语;DE-德语;ES-西班牙语;IT-意大利语;JA-日语; = ['EN', 'ZHCN', 'PL', 'DL', 'RU', 'FR', 'DE', 'ES', 'IT', 'JA']
   */
  to_code?: string
}

/**
 * 接口 翻译接口 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/translation`
 */
export interface TranslationResponse {
  code?: number
  errorInfo?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  isAuthorizedRequest?: boolean
  /**
   * 是否返回正确结果
   */
  isSuccess?: boolean
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 正确结果
   */
  result?: string
  /**
   * 报错接口URI
   */
  targetUrl?: string
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 翻译接口 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/translation`
 */
type TranslationRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/newProduct/translation', 'data', string, string, false>
>

/**
 * 接口 翻译接口 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/translation`
 */
const translationRequestConfig: TranslationRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/translation',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'translation',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 翻译接口 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/translation`
 */
export const translation = /*#__PURE__*/ (requestData: TranslationRequest, ...args: UserRequestRestArgs) => {
  return request<TranslationResponse>(prepare(translationRequestConfig, requestData), ...args)
}

translation.requestConfig = translationRequestConfig

/**
 * 接口 新品名称校验接口 的 **请求类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/validate`
 */
export interface ValidateRequest {
  /**
   * 产品名称（中文）
   */
  cn_name?: string
  /**
   * 虚拟报关名称（中文）
   */
  custom_set_cn_name?: string
  /**
   * 真实报关名称（中文）
   */
  custom_set_cn_name_real?: string
  /**
   * 虚拟报关名称（英文）
   */
  custom_set_en_name?: string
  /**
   * 真实报关名称（英文）
   */
  custom_set_en_name_real?: string
  /**
   * 国内发货中心标识
   */
  deliver_center_id?: number
  /**
   * 产品名称（英文）
   */
  en_name?: string
  /**
   * 采购中心标识
   */
  process_center_id?: number
  /**
   * 特性标注标识集合
   */
  product_label_ids?: number[]
}

/**
 * 接口 新品名称校验接口 的 **返回类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/validate`
 */
export interface ValidateResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  result?: {
    is_success?: boolean
    messages?: {
      cnName?: string
      customSetCnName?: string
      customSetEnName?: string
      enName?: string
    }
    summary?: string
  }
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 新品名称校验接口 的 **请求配置的类型**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/validate`
 */
type ValidateRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/newProduct/validate', 'data', string, string, false>
>

/**
 * 接口 新品名称校验接口 的 **请求配置**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/validate`
 */
const validateRequestConfig: ValidateRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_45,
  devUrl: devUrl_0_0_0_45,
  prodUrl: prodUrl_0_0_0_45,
  path: '/newProduct/validate',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_45,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'validate',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 新品名称校验接口 的 **请求函数**
 *
 * @分类 new-product-controller
 * @请求头 `POST /newProduct/validate`
 */
export const validate = /*#__PURE__*/ (requestData: ValidateRequest, ...args: UserRequestRestArgs) => {
  return request<ValidateResponse>(prepare(validateRequestConfig, requestData), ...args)
}

validate.requestConfig = validateRequestConfig

/* prettier-ignore-end */
